import {getGroupMembers, getGroupMember} from "@/Services/group-members";
import {getGroupQuestions} from "@/Services/group-questions";
//TODO move these events in to relevant sub components
export default (group, params) => {
    return [
        {
            event: "Groups\\GroupMembersSynced",
            callback: async (e: {group: string; attached: Array<string>; detached: Array<string>}) => {
                console.log(e);
                if (e.group !== group.value.id) {
                    return;
                }

                if (e.attached.length) {
                    const {data} = await getGroupMembers(group.value.id, {filter: {user_ids: e.attached}});
                    group.value.members = [...group.value.members, ...data];
                }

                if (e.detached.length) {
                    group.value.members = group.value.members.filter((member) => !e.detached.includes(member.id));
                }
            },
        },
        {
            event: "Groups\\GroupMemberAdded",
            callback: async (e: {group: string; user: string; invitation: string}) => {
                if (e.group !== group.value.id) {
                    return;
                }

                const {data} = await getGroupMember(group.value.id, e.user);
                group.value.members.push(data);

                if (group.value.invitations) {
                    group.value.invitations = group.value.invitations.filter(
                        (invitation) => invitation.id !== e.invitation,
                    );
                }
            },
        },
    ];
};
